import { RegenerateIcon } from "./icons";

// The regenerate (↻) control that trails a generated passphrase, shared by the
// setup and recovery generators so both look and behave identically.
export function RegenerateButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      className="icon-button"
      onClick={onClick}
      aria-label="Regenerate passphrase"
      title="Regenerate passphrase"
    >
      <RegenerateIcon />
    </button>
  );
}

export default RegenerateButton;
